const products = {
    title: 'Typical Abruzzo Products',
    subtitle: 'Discover the authentic flavors of our region',
    errorLoading: 'Error loading products',
    loginRequired: 'Please login to add products to cart',
    addedToCart: 'Product added to cart!',
    errorAddingToCart: 'Error adding to cart',
    noImage: 'No image available',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    loginToAdd: 'Login to Add',
    adding: 'Adding...',
    addToCart: 'Add to Cart',
    noProducts: 'No products available',
    comingSoon: 'Delicious products coming soon to our store',
    categories: {
        cheese: 'Cheese',
        wine: 'Wines',
        oliveOil: 'Olive Oil',
        pasta: 'Pasta',
        salami: 'Cured Meats',
        honey: 'Honey',
        truffle: 'Truffles'
    },
    wine: {
        montepulciano: {
            name: 'Montepulciano d\'Abruzzo DOC',
            description: 'Full-bodied and structured red wine, produced with Montepulciano grapes grown on Abruzzo hills. Notes of ripe red fruits and sweet spices, perfect to pair with red meats and aged cheeses.'
        },
        trebbiano: {
            name: 'Trebbiano d\'Abruzzo DOC',
            description: 'DOC white wine produced with Trebbiano grapes. Fresh and aromatic, perfect for fish dishes.'
        }
    },
    cheese: {
        pecorino: {
            name: 'Pecorino Romano DOP',
            description: 'Aged pecorino cheese produced in Abruzzo according to centuries-old tradition. Intense and aromatic flavor.'
        },
        caciocavallo: {
            name: 'Caciocavallo Silano',
            description: 'Stretched-curd cheese produced with cow\'s milk. Sweet flavor and elastic texture.'
        }
    },
    oliveOil: {
        extraVergine: {
            name: 'Extra Virgin Olive Oil',
            description: 'Organic extra virgin olive oil produced from olives grown in Abruzzo. Fruity and slightly spicy.'
        }
    },
    pasta: {
        chitarra: {
            name: 'Pasta alla Chitarra',
            description: 'Traditional Abruzzo pasta made by hand with durum wheat flour and eggs. Characteristic square-section format.'
        },
        lenticchie: {
            name: 'Santo Stefano Lentils',
            description: 'Lentils grown on the Santo Stefano di Sessanio plateau. Small and flavorful.'
        }
    },
    salami: {
        salsiccia: {
            name: 'Liver Sausage',
            description: 'Traditional Abruzzo sausage prepared with pig liver and spices. Intense and characteristic flavor.'
        }
    },
    honey: {
        castagno: {
            name: 'Chestnut Honey',
            description: 'Monofloral chestnut honey produced in the mountains. Intense flavor and characteristic dark color.'
        }
    },
    truffle: {
        nero: {
            name: 'Black Truffle',
            description: 'Precious black truffle harvested in Abruzzo forests. Intense aroma and unmistakable flavor.'
        }
    }
};

export default products;
